/**
 * When the person last actually did something in this tab — a click, key press, scroll,
 * touch or mouse move. Page load counts as activity.
 *
 * Why: the admin panels auto-refresh every ~10 s. If those refreshes counted as activity,
 * an admin console left open and unattended would never hit its 30-minute idle sign-out.
 * `api-client` marks admin requests made while nobody is at the page as background, and
 * the server doesn't let those reset the idle clock.
 */
export const ACTIVE_WINDOW_MS = 60_000;

const EVENTS = ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart', 'scroll'] as const;

let lastActivityAt = Date.now();

export function markUserActivity(at = Date.now()): void {
  lastActivityAt = at;
}

export function userRecentlyActive(now = Date.now()): boolean {
  return now - lastActivityAt <= ACTIVE_WINDOW_MS;
}

if (typeof window !== 'undefined') {
  for (const name of EVENTS) {
    // capture: `scroll` doesn't bubble; passive: never delays scrolling or touch.
    window.addEventListener(name, () => markUserActivity(), { capture: true, passive: true });
  }
}
